// /review — minimal client-side redirect to the AeroMax Energy Google Review page.
// Not linked from navigation, footer or sitemap. Direct-URL only.
import { useEffect } from "react";
import { ExternalLink, Star } from "lucide-react";

const REVIEW_URL = "https://g.page/r/CZ64xRcfQjSzEBM/review";

export default function ReviewRedirect() {
  useEffect(() => {
    // Add a meta refresh as a legacy/no-JS-timing safety net.
    const meta = document.createElement("meta");
    meta.setAttribute("http-equiv", "refresh");
    meta.setAttribute("content", `0; url=${REVIEW_URL}`);
    document.head.appendChild(meta);

    // Client-side redirect — replace() so the /review URL isn't kept in history.
    window.location.replace(REVIEW_URL);

    return () => {
      if (meta.parentNode) meta.parentNode.removeChild(meta);
    };
  }, []);

  return (
    <section
      data-testid="review-redirect"
      className="min-h-[60vh] flex items-center justify-center bg-white px-6 py-16"
    >
      <div className="max-w-lg w-full text-center">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#10B981]/12 border border-[#10B981]/25 text-[10px] tracking-[0.22em] uppercase font-bold text-[#059669]">
          <Star className="h-3 w-3" strokeWidth={2.4} /> Google Reviews
        </span>
        <h1
          data-testid="review-redirect-heading"
          className="font-heading mt-5 text-2xl sm:text-3xl font-bold text-[#0B132B] leading-tight"
        >
          Taking you to AeroMax Energy&apos;s Google reviews…
        </h1>
        <p className="mt-4 text-sm text-[#475569] leading-relaxed">
          If you&apos;re not redirected automatically, tap the button below.
        </p>
        <a
          data-testid="review-redirect-fallback-btn"
          href={REVIEW_URL}
          className="mt-7 inline-flex items-center gap-2 rounded-full bg-[#10B981] hover:bg-[#059669] text-white px-7 py-3.5 font-semibold transition-all hover:shadow-xl hover:shadow-emerald-500/30"
        >
          Continue to Google Reviews <ExternalLink className="h-4 w-4" />
        </a>
      </div>
    </section>
  );
}
